var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctorbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.313,
    height: 53,
    viewBox: "0 0 56.313 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#1d1602}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_51_",
    transform: "translate(0 -15.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_18_",
    transform: "translate(16.539 15.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1774_",
    d: "M171.96 28.3h-19.935a1.65 1.65 0 0 1-1.65-1.65V20.7a5.643 5.643 0 0 1 5.637-5.637h11.961a5.643 5.643 0 0 1 5.637 5.637v5.953a1.65 1.65 0 0 1-1.65 1.647zm-18.285-2.2h16.635v-5.4a2.34 2.34 0 0 0-2.337-2.337h-11.961a2.34 2.34 0 0 0-2.337 2.337z",
    className: "cls-1",
    transform: "translate(-150.375 -15.062)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1928_",
    d: "M261.98 15.062H256v3.3h5.98a2.34 2.34 0 0 1 2.337 2.337v5.4H256v2.2h9.968a1.65 1.65 0 0 0 1.65-1.65V20.7a5.643 5.643 0 0 0-5.637-5.637z",
    className: "cls-1",
    transform: "translate(-227.843)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_20_",
    transform: "translate(0 25.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1777_",
    d: "M47.927 148.5l-19.77-2.963L8.386 148.5A8.4 8.4 0 0 1 0 140.111v-26.287a8.4 8.4 0 0 1 8.386-8.386l19.77 1.382 19.77-1.382a8.4 8.4 0 0 1 8.386 8.386v26.287a8.4 8.4 0 0 1-8.385 8.389z",
    className: "cls-1",
    transform: "translate(0 -105.438)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1883_",
    d: "M275.77 105.438l-19.77 1.1V147.4l19.77 1.1a8.4 8.4 0 0 0 8.386-8.386v-26.29a8.4 8.4 0 0 0-8.386-8.386z",
    className: "cls-1",
    transform: "translate(-227.843 -80.436)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_",
    transform: "translate(8.386 25.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1768_",
    fill: "#918b7b",
    d: "M115.789 148.5h-39.54v-43.06h39.54z",
    transform: "translate(-76.249 -105.438)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1882_",
    fill: "#6e6652",
    d: "M256 105.438h19.77V148.5H256z",
    transform: "translate(-227.843 -80.436)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_52_",
    transform: "translate(16.567 34.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1771_",
    fill: "rgba(29,22,2,0.92)",
    d: "M165.528 218.992H158.9a1.65 1.65 0 0 1-1.65-1.65v-4.977h-4.977a1.65 1.65 0 0 1-1.65-1.65v-6.627a1.65 1.65 0 0 1 1.65-1.65h4.977v-4.977a1.65 1.65 0 0 1 1.65-1.65h6.627a1.65 1.65 0 0 1 1.65 1.65v4.977h4.977a1.65 1.65 0 0 1 1.65 1.65v6.627a1.65 1.65 0 0 1-1.65 1.65h-4.977v4.977a1.65 1.65 0 0 1-1.649 1.65z",
    transform: "translate(-150.625 -195.812)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1924_",
    d: "M265.94 202.439h-4.977v-4.977a1.65 1.65 0 0 0-1.65-1.65H256v23.18h3.313a1.65 1.65 0 0 0 1.65-1.65v-4.977h4.977a1.65 1.65 0 0 0 1.65-1.65v-6.627a1.65 1.65 0 0 0-1.65-1.649z",
    className: "cls-1",
    transform: "translate(-227.843 -160.87)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorbox);
export default __webpack_public_path__ + "static/media/doctorbox.24375044f4afb7f2c26dbda987ee0ae9.svg";
export { ForwardRef as ReactComponent };